import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { TooltipDirective } from '../tooltip/tooltip.directive';
import { SelectValueAccessorDirective } from '../value-accessors/select-value-accessor.directive';
import { SearchScope } from './search-bar.component';

@Component({
	selector: 'skl-search-filter-select',
	template: `
		<ins-select
			[ngModel]="scope()"
			(ngModelChange)="scope.set($event)"
			(click)="$event.stopPropagation()"
			[tooltip]="'ui.search-bar.scope.tooltip' | translate"
		>
			<span slot="content" class="scope-label">
				@for (option of scopeOptions; track option.value) {
					<span
						[class.is-hidden]="scope() !== option.value"
						[attr.aria-hidden]="scope() !== option.value"
					>
						{{ option.label | translate }}
					</span>
				}
			</span>
			@for (option of scopeOptions; track option.value) {
				<ins-option [value]="option.value">{{ option.label | translate }}</ins-option>
			}
		</ins-select>
	`,
	styles: `
		:host {
			--_focus-color: var(--primary-color-light);
			--_surface: var(--surface-4-color);

			display: flex;
			align-items: center;
			font-size: 0.875rem;
			background-color: var(--_surface);
			padding-inline: var(--gutter-small);
			cursor: pointer;
			color: var(--text-minor-color);
			transition: background-color 0.2s ease, outline 0.2s ease, outline-offset 0.2s ease;

			&:has(:focus-visible) {
				color: var(--text-color);
				outline: 2px solid var(--_focus-color);
				outline-offset: 2px;
			}

			&:hover {
				color: var(--text-color);
				background-color: color-mix(in oklab, var(--_surface), light-dark(black, white) 10%);
			}
		}

		ins-select {
			inline-size: 100%;
			outline: none;

			&.is-open {
				color: var(--text-color);
			}
		}

		.scope-label {
			display: grid;

			> span {
				grid-area: 1 / 1;
			}

			.is-hidden {
				visibility: hidden;
			}
		}
	`,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [FormsModule, SelectValueAccessorDirective, TooltipDirective, TranslatePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterSelectComponent {
	public readonly scope = model<SearchScope>('all');

	protected readonly scopeOptions: readonly { readonly value: SearchScope; readonly label: string }[] = [
		{ value: 'all', label: 'ui.search-bar.scope.all' },
		{ value: 'filtered', label: 'ui.search-bar.scope.filtered' },
	];
}
